import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class VersionSwitcherViewProvider {
	private readonly GAP_PX = 56;
	private readonly PANEL_HEADER = 48;
	private readonly ALERT_HEIGHT = 56;

	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const modalContent =
			elemRef.nativeElement.querySelector('.app-modal-content');

		const versionSwitcherProjectList = document.querySelector(
			'.app-version-switcher-project-list'
		) as HTMLElement | null;

		const projectListHeight =
			modalContent.offsetHeight -
			this.GAP_PX -
			this.PANEL_HEADER -
			this.ALERT_HEIGHT;

		renderer.setStyle(
			versionSwitcherProjectList,
			'--max-height-projects',
			`${projectListHeight}px`,
			RendererStyleFlags2.DashCase
		);
	}
}
